import React from "react";
import { Box, TextField } from "@material-ui/core";
import { Typography, useMediaQuery } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import { useSnackbar } from "../Snakbar";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .matches(/[0-9]{10}$/, "Phone number must be exactly 10 digits")
    .required("Phone number is required"),
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

function FormObjective({ handleCloseDialog, setFilters = () => {} }) {
  const { showSnackbar } = useSnackbar();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  // Default form values
  const initialValues = { name: "", phone: "", email: "" };

  const handleSubmit = (values, { resetForm }) => {
    sessionStorage.setItem("formData", JSON.stringify(values));
    resetForm();
    showSnackbar("Form submitted successfully!", "success");
    if (handleCloseDialog) handleCloseDialog();
  };

  return (
    <Box
      sx={{
        maxWidth: 700,
        margin: "auto",
        padding: 5,
        background: "#f5f5f5",
        borderRadius: "12px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          textAlign: "center",
          marginBottom: 2,
          color: "#333",
          fontWeight: "bold",
        }}
      >
        Schedule A Meeting
      </Typography>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          handleChange,
          handleBlur,
          values,
          errors,
          touched,
          isSubmitting,
          resetForm,
        }) => (
          <Form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              padding: "0 20px",
            }}
          >
            <Field
              as={TextField}
              label="Name"
              name="name"
              variant="outlined"
              fullWidth
              size={isSmallScreen ? "small" : "medium"}
              error={touched.name && Boolean(errors.name)}
              helperText={touched.name && errors.name}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <Field
              as={TextField}
              label="Phone"
              name="phone"
              variant="outlined"
              fullWidth
              size={isSmallScreen ? "small" : "medium"}
              error={touched.phone && Boolean(errors.phone)}
              helperText={touched.phone && errors.phone}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <Field
              as={TextField}
              label="Email"
              name="email"
              variant="outlined"
              fullWidth
              size={isSmallScreen ? "small" : "medium"}
              error={touched.email && Boolean(errors.email)}
              helperText={touched.email && errors.email}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <LoadingButton
              type="submit"
              variant="contained"
              fullWidth
              sx={{
                marginTop: 2,
                marginBottom: 2,
                background: "#00999e",
                color: "white",
                fontWeight: "bold",
                padding: "12px",
                "&:hover": { background: "#007d80" },
              }}
              loading={isSubmitting}
            >
              Submit
            </LoadingButton>
          </Form>
        )}
      </Formik>
    </Box>
  );
}

export default FormObjective;
